<template>
    <el-container class="element-sideEditor">
        <el-aside width="229px">
            <div class="search-opt-btns">
                <el-button type="primary" icon="el-icon-search" @click="searchForList">查询</el-button>
                <el-button icon="el-icon-refresh" @click="resetSearchConditon">重置</el-button>
            </div>
            <div class="operate-search" :style="activeStyle()">
                <el-collapse v-model="activeName" @change="handleChange" accordion>
                    <el-collapse-item
                        v-for="(conditionField, index) in conditionFields"
                        :key="conditionField.id"
                        :name="index">
                        <template slot="title" >
                            <div class="button-title">
                                <i class="el-icon-caret-right">{{conditionField.name}}</i>
                            </div>
                            <div class="form-item-option">
                                <i class="el-icon-delete" @click.stop="handleDeleteItem(index)" title="删除"></i>
                            </div>
                        </template>
                        <el-form size="mini" label-width="80px" class="button-props">
                            <el-form-item label="条件">
                              <el-select v-model="conditionField.operateType" placeholder="请选择">
                                  <el-option label="包含" :value='1'></el-option>
                                  <el-option label="等于" :value='2'></el-option>
                                  <el-option label="不等于" :value='3'></el-option>
                                  <template v-if="conditionField.type === 'date'">
                                      <el-option label="范围" :value='6'></el-option>
                                  </template>
                                  <template v-else>
                                      <el-option label="大于等于" :value='4'></el-option>
                                      <el-option label="小于等于" :value='5'></el-option>
                                  </template>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="内容">
                                <template v-if="conditionField.type === 'date'">
                                        <template v-if="conditionField.operateType === 6">
                                        <el-date-picker type="date" v-model="conditionField.conditionValueSdt" :value-format="formatField(conditionField)" :format="formatField(conditionField)" :editable="true" placeholder="开始时间" style="width: 100%;"></el-date-picker>
                                        <el-date-picker type="date" v-model="conditionField.conditionValueEdt" :value-format="formatField(conditionField)" :format="formatField(conditionField)" :editable="true" placeholder="结束时间" style="width: 100%;"></el-date-picker>
                                    </template>
                                    <template v-else>
                                        <el-date-picker type="date" v-model="conditionField.conditionValue" :value-format="formatField(conditionField)" :format="formatField(conditionField)" :editable="true" placeholder="选择日期" style="width: 100%;"></el-date-picker>
                                    </template>
                                </template>
                                <template v-else>
                                    <SearchConditionFieldItem  :key="conditionField.id" :field="conditionField" :formData="formData" :multiple="true"/>
                                </template>
                            </el-form-item>
                            <el-form-item v-if="conditionField.type === 'text' || conditionField.type === 'date' || conditionField.type === 'calculation' || conditionField.type === 'subFormSummary' || conditionField.type === 'serialNumber' || conditionField.type === 'number'" label="排序">
                                <el-select clearable v-model="conditionField.orderByRule"  placeholder="请选择">
                                    <el-option label="不排序" value=''></el-option>
                                    <el-option label="升序" value='ASC'></el-option>
                                    <el-option label="降序" value='DESC'></el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </el-aside>
    </el-container>
</template>
<script>
    import SearchConditionFieldItem from './SearchConditionFieldItem';
    export default {
        components: {
            SearchConditionFieldItem
        },
        data () {
            return {
                activeName: 0,
                formData: {}
            };
        },
        props: {
            conditionFields: {
                type: Array
            },
            fullScreen: {
                type: Boolean,
                default: false
            }
        },
        created () {
        },
        methods: {
            getConditionOpts (type) {
                let options = [{
                    value: 1,
                    label: '包含'
                }, {
                    value: 2,
                    label: '等于'
                }, {
                    value: 3,
                    label: '不等于'
                }];
                if (type === 'date') {
                    options.push({
                        value: 6,
                        label: '范围'
                    });
                }
                return options;
            },
            handleDeleteItem (index) {
                this.conditionFields.splice(index, 1);
            },
            getSearchCondition () {
                return this.conditionFields;
            },
            handleChange (val) {
                // console.log(val);
            },
            searchForList () {
                this.$emit('searchForList', this.conditionFields);
            },
            resetSearchConditon () {
                this.$emit('resetSearchConditon', true);
            },
            activeStyle () {
                let style = {};
                if (this.fullScreen) {
                    style = {
                        'height': '575px',
                        'overflow-y': 'auto'
                    };
                } else {
                    style = {
                        'height': 'auto',
                        'overflow-y': 'auto'
                    };
                }
                return style;
            },
            formatField (obj) {
                if (!obj.options.ext3 || obj.options.ext3 === '') {
                    return 'yyyy-MM-dd';
                } else if (obj.options.ext3 === '1') {
                    return 'yyyy-MM';
                } else if (obj.options.ext3 === '2') {
                    return 'yyyy';
                }
            }
        }
    };
</script>


<style lang="less">
  .element-sideEditor {
        .exec-type {
            .el-radio+.el-radio {
                margin-left: 0;
            }
        }
        .search-opt-btns{
            display: flex;
            flex:1;
            position: fixed;
            // top: 92px;
            width: 205px;
            padding-left: 30px;
            padding-top: 8px;
            padding-bottom: 8px;
            background-color: white;
            z-index: 1;
            border: 1px solid #ebeef5;
        }
        .operate-search {
            display: flex;
            flex-direction: column;
            margin-top:50px;
            .el-collapse {
                border-left: 1px solid #ebeef5;
                border-right: 1px solid #ebeef5;
            }

            .button-title {
                padding: 0 0 0 10px;
                flex:8;
            }

            .form-item-option {
                flex:1;
                cursor: pointer;
                display: inline-block;
            }


            .button-list {
                display: flex;
                flex-direction: column;
            }
            .button-props {
                // width: 600px;
                margin-right: 10px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/SearchCondition/SearchConditionSide.vue